import { render } from "./Government.vue?vue&type=template&id=392c2df6"
import script from "./Government.vue?vue&type=script&lang=js"
export * from "./Government.vue?vue&type=script&lang=js"
script.render = render

export default script